var _excluded = ["children", "initialActiveTab", "subtitle", "title", "setActive", "analytics"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import Panel from './panel';
import Tablist from '../tablist';
require("./tabpanel.css");
var styles = {
  "tabpanelTitle": "tabpanelTitle-2sgGF",
  "tabpanelSubtitle": "tabpanelSubtitle-4pCPZ"
};
var Tabpanel = _ref => {
  var {
      children,
      initialActiveTab,
      subtitle,
      title,
      setActive,
      analytics
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var tabpanelRefs = [];
  var tablistRef = useRef(null);
  var [activeTab, setActiveTab] = useState(initialActiveTab);
  var [visibleTab, setVisibleTab] = useState(initialActiveTab);
  useEffect(() => {
    setActiveTab(initialActiveTab);
    setVisibleTab(initialActiveTab);
  }, [initialActiveTab]);
  useEffect(() => {
    if (tabpanelRefs.length === 0) return;
    tabpanelRefs[activeTab].focus({
      preventScroll: true
    });

    // rule disabled because the component does not support adding/removing tabs dynamically
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);
  var handleTabClick = index => {
    setActiveTab(index);
    setVisibleTab(index);
    if (setActive) {
      setActive(index);
    }
  };
  var handleKeyDown = (event, index) => {
    var groupLength = children.length;
    switch (event.key) {
      case 'ArrowRight':
        {
          var newIndex = index + 1;
          if (newIndex >= groupLength) {
            // loop back to beginning
            newIndex = 0;
          }
          // timeout prevents webkit bug where scroll position is misreported after focus
          setTimeout(() => {
            setVisibleTab(newIndex);
          }, 0);
          tabpanelRefs[newIndex].focus({
            preventScroll: true
          });
          break;
        }
      case 'ArrowLeft':
        {
          var _newIndex = index - 1;
          if (_newIndex < 0) {
            // loop back to end
            _newIndex = groupLength - 1;
          }
          // timeout prevents webkit bug where scroll position is misreported after focus
          setTimeout(() => {
            setVisibleTab(_newIndex);
          }, 0);
          tabpanelRefs[_newIndex].focus({
            preventScroll: true
          });
          break;
        }
      default:
        return true;
    }
    return true;
  };
  var mapAnalytics = (name, index) => {
    if (!analytics) {
      return {};
    }
    var analyticsProps = _objectSpread({}, analytics);
    // eslint-disable-next-line sonarjs/no-duplicate-string
    analyticsProps['data-lulu-attributes']['component'].name = name.trim();
    analyticsProps['data-lulu-attributes']['component'].index = index;
    analyticsProps['data-lulu-attributes'] = JSON.stringify(analyticsProps['data-lulu-attributes']);
    return analyticsProps;
  };
  return /*#__PURE__*/React.createElement("div", otherProps, !!title && /*#__PURE__*/React.createElement("h2", {
    className: cs('lll-text-xsmall', styles.tabpanelTitle)
  }, title), !!subtitle && /*#__PURE__*/React.createElement("p", {
    className: styles.tabpanelSubtitle
  }, subtitle), /*#__PURE__*/React.createElement(Tablist, {
    inViewIndex: visibleTab,
    ref: tablistRef,
    role: "tablist",
    selectedIndex: activeTab
  }, React.Children.map(children, (_ref2, index) => {
    var {
      props: {
        id,
        label,
        disabled
      }
    } = _ref2;
    return /*#__PURE__*/React.createElement("button", _extends({
      className: "lll-text-primary",
      "aria-controls": "".concat(id, "-tabpanel"),
      "aria-selected": activeTab === index
    }, mapAnalytics(label, index), {
      id: "".concat(id, "-tab"),
      key: label,
      onClick: () => handleTabClick(index),
      onKeyDown: e => handleKeyDown(e, index),
      ref: el => {
        tabpanelRefs[index] = el;
      },
      role: "tab",
      tabIndex: activeTab === index ? '0' : '-1',
      type: "button",
      disabled: disabled
    }), label);
  })), /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.map(children, (child, index) => {
    return child ? /*#__PURE__*/React.cloneElement(child, {
      ariaLabelledby: "".concat(child.props.id, "-tab"),
      id: "".concat(child.props.id, "-tabpanel"),
      isSelected: activeTab === index
    }) : null;
  })));
};
Tabpanel.propTypes = {
  /** A <Panel /> node. Each Panel should have an `id` and a `label` to be used for the associated Tab. */
  children: PropTypes.node.isRequired,
  /** Initial tab number to show on render */
  initialActiveTab: PropTypes.number,
  /** An optional paragraph to show below the title. */
  subtitle: PropTypes.string,
  /** An optional h2 title to show above the tabpanel. */
  title: PropTypes.string,
  /** An optional funcion to notify the parent component which tab is selected. */
  setActive: PropTypes.func,
  /** An optional object for data analytics */
  analytics: PropTypes.objectOf(PropTypes.shape({
    'data-lulu-track': PropTypes.string,
    'data-lulu-attributes': PropTypes.shape({
      index: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.string,
      component: PropTypes.shape({
        type: PropTypes.string
      })
    })
  }))
};
Tabpanel.defaultProps = {
  initialActiveTab: 0,
  subtitle: '',
  title: '',
  setActive: null,
  analytics: null
};
Tabpanel.Panel = Panel;
export default Tabpanel;